import React from "react";
import { Modal, Button, COLORS, Icon, Link, Text } from "@ui-component-library";
import { ContentContainer, GrowingContainer, IconContainer, StyledIcon } from "./utils/utils";
import { formatNumber } from "../../../utils";

export const CarbonValueStep = ({ currentStepIndex, totalSteps, handleBack, handleNext, handleClose,arbonicsData }) => {
  const handleSubmit = async () => {
    handleNext({
      stepsToSkip: arbonicsData.sbo ? 2 : 1
    });
  };

  const selectedProp = arbonicsData?.selectedProp;
  const arbonics = selectedProp?.arbonics ?? selectedProp?.data?.arbonics;

  const eligibleValue = arbonics?.eligible;

  const arbonicsEligible = eligibleValue == 2;
  const notArbonicsEligible = !arbonicsEligible && eligibleValue !== undefined;

  const hasDfr = !!selectedProp?.dfr;
  const arbonicsHa = arbonics?.ha 
  
  const arbonicsPrice = arbonics?.price;

  return (
    <>
      <Modal.Content>
        <ContentContainer >
          <GrowingContainer className="bg-neutral-stone-100 rounded-3 text-center">
          <>
          <div className="flex justify-center">
              <img
                src={Window.static_path + "img/other/river_in_forest.webp"}
                alt="carbon image"
                className="rounded-xl overflow-hidden w-full h-[300px] object-cover object-bottom"
              />
            </div> 
            <div className="text-left flex flex-col gap-3 mb-2">
              { arbonicsEligible && hasDfr ?<><Text variant="text-sm/leading-normal/medium">Fantastiskt! Din fastighet har en  potential på  {formatNumber(parseFloat(arbonicsHa))} hektar att skapa nytt värde genom kolkrediter via förlängd omloppstid. Detta är ett smart sätt att maximera skogens alla värden.</Text>
              <Text variant="text-sm/leading-normal/medium">Vi uppskattar att detta kan innebära en potentiell intäkt på upp till  {formatNumber(arbonicsPrice)} SEK för dig som skogsägare.</Text>
              <Text variant="text-sm/leading-normal/medium">Vill du ta nästa steg och låsa upp denna potential?</Text>
              <Text variant="text-sm/leading-normal/medium">Som Treebula Plus-medlem får du tillgång till våra avancerade verktyg och kan nu initiera den verifieringsprocess som krävs för att starta ett kolkreditprojekt.</Text>
              <Text variant="text-sm/leading-normal/medium">Nästa steg: Verifiering</Text>
              <Text variant="text-sm/leading-normal/medium">Innan projektet kan startas fullt ut krävs en ytterligare verifiering av potentialen på din mark. Detta säkerställer kvaliteten och värdet på dina kolkrediter.</Text>
              <Text variant="text-sm/leading-normal/medium">Vi på Treebula guidar dig genom hela denna process, från verifiering till försäljning. Vi finns tillgängliga om du har några funderingar kring kolkrediter eller vill veta mer om hur det fungerar.</Text>
                  <Text variant="text-sm/leading-normal/medium">Har du frågor eller vill veta mer? Klicka på Boka genomgång eller skriv till oss på <Link
                    href="mailto:information@treebula.se"
                    target="blank"
                    underline
                  >
                    information@treebula.se.
                  </Link> </Text>
              </>: 
              (arbonicsEligible && !hasDfr )  ? <> 
                <Text variant="text-sm/leading-normal/medium">Din fastighet har potential att <span className="font bold">skapa nytt värde</span> genom kolkrediter via förlängd omloppstid. Detta är ett smart sätt att maximera skogens alla värden.</Text>
                <Text variant="text-sm/leading-normal/medium">Vill du se din exakta potential i kronor?</Text>
                <Text variant="text-sm/leading-normal/medium">Som Treebula Plus-medlem får du tillgång till våra avancerade analysverktyg och ser direkt vad din skog kan generera i intäkter.</Text>
                <Text variant="text-sm/leading-normal/medium">Bli Plusmedlem och se din potential via knappen nedan</Text>
                <Text variant="text-sm/leading-normal/medium">Har du frågor om hur kolkrediter från skog fungerar, eller vill du få en djupare förståelse för processen?</Text>
                <Text variant="text-sm/leading-normal/medium"><Link
                    href="/min-skog/demo/"
                    underline
                  >
                    Utforska plus
                  </Link> klicka runt i vår demo i din egen takt.</Text>
                <Text variant="text-sm/leading-normal/medium">Vi finns alltid här för dig: <Link
                    href="mailto:information@treebula.se"
                    target="blank"
                    underline
                  >
                    information@treebula.se.
                  </Link></Text>
              </>:  notArbonicsEligible && !hasDfr ?<>
              <Text variant="text-sm/leading-normal/medium">Vi har analyserat din fastighet och kan tyvärr inte se någon potential för kolkrediter via förlängd omloppstid just nu. Men var lugn, din skog är full av andra värden som väntar på att realiseras!</Text>
                <Text variant="text-sm/leading-normal/medium">Som Treebula Plus-medlem får du den kunskap och kontroll du behöver för ett lönsamt skogsägande:</Text>
                <ul className='list-disc list-inside flex flex-col gap-2 '>
                  <li><Text variant="text-sm/leading-normal/medium" className="inline">Få full kontroll: Se din digitala skogsbruksplan och håll koll på din fastighet med vår Skogsövervakning (som varnar dig för vindfällen och barkborreangrepp).</Text></li>
                  <li><Text variant="text-sm/leading-normal/medium" className="inline">Maximera din försäljning: Få tillgång till vår marknadsplats där du kan jämföra priser och sälja virke och biobränsle till marknadens bästa villkor.</Text></li>
                  <li><Text variant="text-sm/leading-normal/medium" className="inline">Ta smarta beslut: Använd våra avancerade analysverktyg och få oberoende rådgivning.</Text></li>
                </ul>
                <Text variant="text-sm/leading-normal/medium">Du skaffar Treebula Plus via knappen nedan och låser upp alla dessa möjligheter.</Text>
                
              </>:<Text variant="text-sm/leading-normal/medium">Vi kan tyvärr inte se att fastigheten har någon potential för kolkrediter enligt vår preliminära analys. Det går bra att ändå göra en intresseanmälan så kikar vi lite extra noggrant. Har du några frågor går det alltid bra att kontakta oss via <Link 
                    href="mailto:information@treebula.se"
                    target="blank"
                    underline> information@treebula.se </Link></Text>} 
            </div> 
          </>
          
          </GrowingContainer>
        </ContentContainer>
      </Modal.Content>
      <Modal.Footer>
        <>
          {hasDfr ? <Button
            fullWidth
            variant="primary"
            onClick={handleSubmit}
          ><React.Fragment key=".0">
              Nästa steg
              <Icon
                color="charcoal-500"
                name="ArrowRightSimple"
                size="large"
              />
            </React.Fragment></Button>:
            <div className="flex justify-between w-full">
              <Button
                variant="secondary"
                onClick={()=>{window.location.href="/min-skog/demo/"; handleClose}}
                disabled={''}
              >Utforska plus</Button>
              <Button
                variant="primary"
                onClick={()=>{window.location.href = "/min-skog/?view=pricing"; handleClose}}
              ><React.Fragment key=".0">
                  Bli Plusmedlem
                  <Icon
                    color={"white-500"}
                    name="ArrowRightSimple"
                  />
                </React.Fragment>
                </Button>
            </div>}
        </>
      </Modal.Footer>
    </>
  );
};

